import { getCurrentYear } from "@/utils/AvailableYears";
import { useQueryClient } from "@tanstack/react-query";
import { createContext, useContext, useEffect, useMemo, useState } from "react";

interface HistoricYearContextType {
  year: number;
  handleYearChange: React.Dispatch<React.SetStateAction<number>>;
}

const HistoricYearContext = createContext<HistoricYearContextType>({
  year: getCurrentYear(),
  handleYearChange: () => {},
});

export function HistoricYearProvider({ children }: React.PropsWithChildren) {
  const [year, setYear] = useState<number>(getCurrentYear());
  const queryClient = useQueryClient();

  const value = useMemo(() => {
    return {
      year,
      handleYearChange: setYear,
    };
  }, [year]);

  useEffect(() => {
    queryClient.invalidateQueries();
  }, [year, queryClient]);

  return <HistoricYearContext.Provider value={value}>{children}</HistoricYearContext.Provider>;
}

export const useHistoricYear = () => useContext(HistoricYearContext);
